import Fuse from "fuse.js";

export default defineNuxtPlugin((nuxtApp) => {
   nuxtApp.provide("fuse", Fuse);
});
